export var EARLY_TERMINATION_FEE_CHARGE_TYPES = {
  FLAT: 1,
  SLIDING: 2,
  TIERED: 3
};